import api from './authService'

export interface TestStep {
  action: string
  expectedResult: string
}

export interface TestCase {
  id: string
  userStoryId: string
  projectId: string | null
  tcCode: string | null
  title: string
  description: string | null
  type: string | null
  priority: string | null
  status: string | null
  preConditions: string[] | null
  steps: TestStep[] | null
  postConditions: string[] | null
  createdBy: string | null
  updatedBy: string | null
  createdAt: string
  updatedAt: string
}

export const testCaseService = {
  async getTestCases(params: { userStoryId?: string; projectId?: string }) {
    const response = await api.get('/test-cases', { params })
    return response.data
  },

  async generateTestCases(data: { userStoryId: string; extraContext?: string; regenerate?: boolean; count?: number }) {
    const response = await api.post('/test-cases/generate', data)
    return response.data
  },

  async getTestCase(id: string) {
    const response = await api.get(`/test-cases/${id}`)
    return response.data
  },

  async createTestCase(data: Partial<TestCase>) {
    const response = await api.post('/test-cases', data)
    return response.data
  },

  async updateTestCase(id: string, data: Partial<TestCase>) {
    const response = await api.put(`/test-cases/${id}`, data)
    return response.data
  },

  async deleteTestCase(id: string) {
    const response = await api.delete(`/test-cases/${id}`)
    return response.data
  }
}
